import rusticElegance from "../img/buchete-de-toamna/1rustic_elegance.webp";
import wineBouquet from "../img/buchete-de-toamna/2wine-bouquet.webp";
import creamCascade from "../img/buchete-de-toamna/3cream-cascade.webp";
import rustyRose from "../img/buchete-de-toamna/4rusty-rose.webp";
import autumnBreeze from "../img/buchete-de-toamna/5autumn-breeze.webp";
import mulledWine from "../img/buchete-de-toamna/6mulled-wine.webp";
import burgundyBliss from "../img/buchete-de-toamna/7burgundy-bliss.webp";
import orchidFall from "../img/buchete-de-toamna/8orchid_fall.webp";
import mochaCharm from "../img/buchete-de-toamna/9mocha-charm.webp";
import chrisantemaMix from "../img/buchete-de-toamna/10chrisantema_mix.webp";
import colorSerenade from "../img/buchete-de-toamna/11color-serenade.webp";
import fallingForYou from "../img/buchete-de-toamna/12falling-for-you.webp";
import scarlet from "../img/buchete-de-toamna/13scarlet.webp";
import romanticWhisper from "../img/buchete-de-toamna/14romantic-whisper.webp";
import chrisantemaRose from "../img/buchete-de-toamna/15chrisantema-rose.webp";
import frostedFall from "../img/buchete-de-toamna/16frosted_fall.webp";
import radianceFall from "../img/buchete-de-toamna/17radiance-fall.webp";
import autumnHarvest from "../img/buchete-de-toamna/18autumn-harvest.webp";
import softBloom from "../img/buchete-de-toamna/19soft-bloom.webp";
import romanticFall from "../img/buchete-de-toamna/20romantic-fall.webp";
import wineOrchid from "../img/buchete-de-toamna/21wine-orchid.webp";
import twilight from "../img/buchete-de-toamna/22twilight.webp";
import sunsetHues from "../img/buchete-de-toamna/23sunset-hues.webp";
import whisper from "../img/buchete-de-toamna/24whisper.webp";
import honeyHarmony from "../img/buchete-de-toamna/25honey_harmony.webp";
import velvetAutumn from "../img/buchete-de-toamna/26velvet-autumn.webp";
import sunsetParadise from "../img/buchete-de-toamna/27sunset-paradise.webp";
import yellowDream from "../img/buchete-de-toamna/28yellow-dream.webp";
import marigoldPumpkin from "../img/buchete-de-toamna/29marigold_pumpkin.webp";
import pumkinOrchid from "../img/buchete-de-toamna/30pumpkin-orchid.webp";

//1301-1400
const bucheteDeToamna = [
  {
    id: 1301,
    name: "Rustic Elegance",
    price: "1650 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, trandafiri de tip crenguta, astilbe si eucalipt.",
    images: [rusticElegance],
  },
  {
    id: 1302,
    name: "Wine Bouquet",
    price: "1100 lei",
    description:
      "Buchet format din orhidei, crizantema, trandafiri de tip bujor, eustoma si eucalipt. ",
    images: [wineBouquet],
    checkAvailability: true,
  },
  {
    id: 1303,
    name: "Cream Cascade",
    price: "900 lei",
    description:
      "Buchet format din trandafiri, orhidei, eustome, antirinium si eucalipt.",
    images: [creamCascade],
    checkAvailability: true,
  },

  {
    id: 1304,
    name: "Rusty Rose",
    price: "1100 lei",
    description:
      "Buchet format din trandafiri, crizanteme, anturium, eucalipt si verdeata decorativa.",
    images: [rustyRose],
  },
  {
    id: 1305,
    name: "Autumn Breeze",
    price: "1300 lei",
    description:
      "Buchet format din hortensii, eustome, crizanteme, skimia, wax flower si eucalipt.",
    images: [autumnBreeze],
    checkAvailability: true,
  },
  {
    id: 1306,
    name: "Mulled Wine",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, orhidei, crizanteme, lilie si eucalipt.",
    images: [mulledWine],
  },
  {
    id: 1307,
    name: "Burgundy Bliss",
    price: "600 lei",
    description: "Buchet format din crizanteme si eucalipt. ",
    images: [burgundyBliss],
  },
  {
    id: 1308,
    name: "Orchid Fall",
    price: "950 lei",
    description:
      "Buchet format din crizanteme, orhidei, trandafiri, fresie, gipsofila si eucalipt.",
    images: [orchidFall],
    checkAvailability: true,
  },
  {
    id: 1309,
    name: "Mocha Charm",
    price: "1400 lei",
    description:
      "Buchet format din hortensii, trandafiri, crizanteme si eucalipt.",
    images: [mochaCharm],
  },
  {
    id: 1310,
    name: "Chrisantema Mix",
    price: "500 lei",
    description: "Buchet mono format din crizanteme.",
    images: [chrisantemaMix],
  },
  {
    id: 1311,
    name: "Color Serenade",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri, crizanteme, anturium si azothamus.",
    images: [colorSerenade],
  },
  {
    id: 1312,
    name: "Falling For You",
    price: "2200 lei",
    description:
      "Buchet format din hortensii, trandafiri, eustome, gherbere si astilbe.",
    images: [fallingForYou],
  },
  {
    id: 1313,
    name: "Scarlet",
    price: "1250 lei",
    description:
      "Buchet format din hortensie, trandafiri, crizanteme, eustome si eucalipt.",
    images: [scarlet],
  },
  {
    id: 1314,
    name: "Romantic Whisper",
    price: "1450 lei",
    description:
      "Buchet format din hortensie, trandafiri, anturium, crizanteme si eucalipt.",
    images: [romanticWhisper],
  },
  {
    id: 1315,
    name: "Chrisantema Rose",
    price: "900 lei",
    description:
      "Buchet format din crizanteme, trandafiri, eustome, astromerii, azothamus si eucalipt.",
    images: [chrisantemaRose],
  },
  {
    id: 1316,
    name: "Frosted Fall",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, gherbere, trandafiri si crizanteme.",
    images: [frostedFall],
    checkAvailability: true,
  },
  {
    id: 1317,
    name: "Radiance Fall",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri, crizanteme, lilie si azothamus.",
    images: [radianceFall],
  },
  {
    id: 1318,
    name: "Autumn Harvest",
    price: "1850 lei",
    description:
      "Buchet format din hortensie, crizanteme, fresii, garoafe, azothamus si gipsofila.",
    images: [autumnHarvest],
    checkAvailability: true,
  },
  {
    id: 1319,
    name: "Soft Bloom",
    price: "1100 lei",
    description:
      "Buchet format din hortensie, crizanteme, orhidee, gipsofila si eucalipt.",
    images: [softBloom],
    checkAvailability: true,
  },
  {
    id: 1320,
    name: "Romantic Fall",
    price: "900 lei",
    description:
      "Buchet format din hortensie, crizanteme, eustome, trandafiri.",
    images: [romanticFall],
    checkAvailability: true,
  },
  {
    id: 1321,
    name: "Wine Orchid",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, orhidei, crizanteme, trandafiri, lilie, antirinium si eucalipt.",
    images: [wineOrchid],
    checkAvailability: true,
  },
  {
    id: 1322,
    name: "Twilight",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri, crizanteme, anturium si eucalipt.",
    images: [twilight],
  },
  {
    id: 1323,
    name: "Sunset Hues",
    price: "1800 lei",
    description:
      "Buchet format din hortensie, eustome, crizanteme, antirinium, hypericum, delphinium si eucalipt.",
    images: [sunsetHues],
  },
  {
    id: 1324,
    name: "Whisper",
    price: "1200 lei",
    description:
      "Buchet format din crizanteme, gherbere, eustome, lilii, dhiantus si trandafiri.",
    images: [whisper],
  },
  {
    id: 1325,
    name: "Honey Harmony",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, crizanteme, eustome, trandafiri, delphinium si eucalipt.",
    images: [honeyHarmony],
    checkAvailability: true,
  },
  {
    id: 1326,
    name: "Velvet Autumn",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome si eucalipt.",
    images: [velvetAutumn],
  },
  {
    id: 1327,
    name: "Sunset Paradise",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, crizanteme, eustomem, trandafiri si gipsofila.",
    images: [sunsetParadise],
    checkAvailability: true,
  },
  {
    id: 1328,
    name: "Yellow Dream",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, anturium, lilie, crizanteme si eucalipt.",
    images: [yellowDream],
  },
  {
    id: 1329,
    name: "Marigold Pumpkin",
    price: "1500 lei",
    description:
      "Compozitie in dovleac formata din trandafiri, crizanteme, antirinium, crengi decorative si verdeata decorativa.",
    images: [marigoldPumpkin],
  },
  {
    id: 1330,
    name: "Pumpkin Orchid",
    price: "1000 lei",
    description:
      "Compozitie in dovleac formata din crizanteme, orhidei, trandafiri, eustome si verdeata decorativa.",
    images: [pumkinOrchid],
  },
];

export default bucheteDeToamna;
